import Paper from "@mui/material/Paper";
import React from "react";

export const QueryPanel = () => {
  return <Paper>Queery Panel</Paper>;
};
